import Vue from "vue";
import SolicitacaoService from "../domain/atendimento/SolicitacaoService";
import ServicoService from "../domain/atendimento/ServicoService";
import SwalMessage from "../domain/message/SwalMessage";
import Swal from "sweetalert2";

const duplicidadeAtendimento = async ({ next, router, to, store }) => {
  const servicoId = atob(to.params.servico);

  const servicoService = new ServicoService(Vue.http);
  const servico = await servicoService
    .getServico(servicoId, store.state.usuario.id)
    .then(result => result)
    .catch(err => {
      SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
    });

  if (!servico || !servico.servicoAtivo) {
    SwalMessage.warningMessage(
      "<p>Este serviço não está disponível no momento!!.</p>",
      "Ops!"
    );
    return router.push("/atendimento");
  }

  const solicitacaoService = new SolicitacaoService(Vue.http);
  const solicitacao = await solicitacaoService
    .getSolicitacaoByServico(servicoId, store.state.usuario.id)
    .then(result => result)
    .catch(err => {
      SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
    });

  if (!solicitacao || servico.multiplos === 1) {
    return next();
  }

  if (solicitacao.concluidaEm == null) {
    SwalMessage.warningMessage(
      `<p>Verificamos que você possui atendimento(s) em aberto sobre este assunto.</p>
        <p>Você será redirecionado para uma nova interação.</p>
        <p>Para visualizar o seu atendimento em aberto
          <a href="/atendimento/${solicitacaoService.encodeId(solicitacao.id)}" target="_blank">
            clique aqui
          </a>
        </p>
      `,
      "Atenção!"
    );
    return router.push(
      `/atendimento/responder/${solicitacaoService.encodeId(solicitacao.id)}`
    );
  }

  if (solicitacao.concluidaEm != null && servico.reabertura) {
    Swal({
      title: "Atenção!",
      html: `<p>Verificamos que você possui atendimento(s) em aberto sobre este assunto.</p>
        <p>Para visualizar o seu atendimento 
          <a href="/atendimento/${solicitacaoService.encodeId(solicitacao.id)}" target="_blank">
            clique aqui
          </a>
        </p>
        <p>Deseja realizar uma nova interação neste atendimento?</p>
      `,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não"
    }).then(result => {
      if (result.value) {
        return router.push(
          `/atendimento/responder/${solicitacaoService.encodeId(
            solicitacao.id
          )}`
        );
      }
    });
  }

  const PRIMEIRA_VIA_CRACHA_ESTAGIO = 135;
  const SEGUNDA_VIA_CRACHA_ESTAGIO = 141;

  /* Permitir apenas uma solicitação para emissão de Crachá de Estágio Gratuita */
  if (solicitacao.concluidaEm !== null && Number(servicoId) === PRIMEIRA_VIA_CRACHA_ESTAGIO) {
    SwalMessage.warningMessage(
      `<p>Identificamos que a primeira via já foi retirada.</p>
        <p>Para dar continuidade, será necessário realizar a solicitação da segunda via, a qual possui custo.</p>
        <p>Para consultar o atendimento anterior,
          <a href="/atendimento/${solicitacaoService.encodeId(solicitacao.id)}" target="_blank">
            clique aqui
          </a>
        </p>
      `,
      "Atenção!"
    );
    return router.push(`/atendimento/solicitar/${btoa(SEGUNDA_VIA_CRACHA_ESTAGIO)}`);
  }
};

export default duplicidadeAtendimento;



// WEBPACK FOOTER //
// ./src/middleware/duplicidadeAtendimento.js